const CARDS: Array<{ kind: string; format: string; desc: string }> = [
  {
    kind: "Baseline Record",
    format: "DOCX",
    desc: "Audit-trail of every answer, every score, every consistency check, every gap.",
  },
  {
    kind: "Canvas State",
    format: "JSON",
    desc: "Machine-readable. Diff-able across revisions. Pipe it into anything.",
  },
  {
    kind: "Governance Report",
    format: "DOCX",
    desc: "12-section narrative, ready for board review or deployment sign-off.",
  },
];

export function Artifacts() {
  return (
    <section className="lp-artifacts" aria-labelledby="artifacts-heading">
      <h2 className="lp-artifacts__heading" id="artifacts-heading">
        The documents you walk away with
      </h2>
      <ul className="lp-artifacts__list">
        {CARDS.map((c) => (
          <li key={c.kind} className="lp-artifacts__card">
            <div className="lp-artifacts__card-tag">{c.format}</div>
            <h3 className="lp-artifacts__card-title">{c.kind}</h3>
            <p className="lp-artifacts__card-desc">{c.desc}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
